import{ useEffect } from "react"

export function useOnMount(effect) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [])
}